import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmQueuesEditRoute: InvariantJiraRoute = {
	name: 'csm-queues-edit',
	path: '/jira/customer-service-management/projects/:projectKey/queues/custom/:queueId/edit',
	exact: true,
	query: ['config?'],
};
